import TimeSelectInput from "./TimeSelectInput";
import { changeForm } from "../searchFlightsSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { TimeSelect } from "../../../types";
import { convertTimeSelect } from "../utils";
import { useTranslation } from "react-i18next";

function DepartingTimeInput() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const departingTime = useAppSelector(
    (state) => state.searchFlights.form.departingTimeSelect
  );

  const onSelect = (time: TimeSelect) => {
    dispatch(
      changeForm({
        departingTime: convertTimeSelect(time),
        departingTimeSelect: time,
      })
    );
  };

  return (
    <TimeSelectInput
      id="departure-time-input"
      disabled={false}
      value={departingTime}
      label={t("DEPARTURE_TIME")}
      onSelect={onSelect}
      noTime={false}
    />
  );
}

export default DepartingTimeInput;
